export default "__VITE_ASSET__DSYI4fr8__"